import React from 'react';
import { Container, Card, Row, Col, Alert } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaExchangeAlt, FaLightbulb, FaExclamationTriangle, FaCheckCircle } from 'react-icons/fa';

const Internships = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5 }
  };

  return (
    <div style={{
      minHeight: '100vh',
      paddingTop: '2rem',
      paddingBottom: '4rem',
      width: '100%'
    }}>
      <Container>
        {/* HEADER */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-5"
        >
          <h1 className="text-white fw-bold mb-3">
            Zmiana praktyk
          </h1>
          <p className="text-white-50" style={{ fontSize: '1.2rem' }}>
            Rezygnacja z praktyk – jak to się odbywa
          </p>
        </motion.div>

        <Row className="justify-content-center">
          <Col xs={12} lg={10}>
            {/* INTRO CARD */}
            <motion.div
              {...fadeInUp}
              className="mb-4"
            >
              <Card className="border-0 shadow-lg" style={{ 
                borderRadius: '20px',
                background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(0, 86, 179, 0.1) 100%)'
              }}>
                <Card.Body className="p-4">
                  <p className="mb-3" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                    Jeżeli na praktycznej nauce zawodu jesteś wykorzystywany do prac nie związanych z nauką zawodu, 
                    a przede wszystkim jesteś:
                  </p>
                  <ul style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                    <li className="mb-2">
                      <strong>poniżany, obrażany</strong>, a zamiast uczyć się zawodu ciągle sprzątasz, 
                      a o rzeczywistej nauce zawodu możesz tylko pomarzyć
                    </li>
                  </ul>
                  <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                    umowę możesz rozwiązać. Rodzic robi to razem z dzieckiem, bo podpis Rodzica/Opiekuna 
                    widnieje również na umowie.
                  </p>
                </Card.Body>
              </Card>
            </motion.div>

            {/* TIP CARD */}
            <motion.div
              {...fadeInUp}
              transition={{ delay: 0.1 }}
              className="mb-4"
            >
              <Card
                className="border-0 shadow-lg"
                style={{
                  borderRadius: '20px',
                  background: 'rgba(255, 193, 7, 0.1)',
                  border: '2px solid rgba(255, 193, 7, 0.3)'
                }}
              >
                <Card.Body className="p-4">
                  <h5 className="fw-bold mb-3">
                    <FaLightbulb className="me-2" style={{ color: '#ffc107' }} />
                    TIP !!!
                  </h5>
                  <p className="mb-3" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                    <strong>Zanim z twojej inicjatywy zostanie rozwiązana umowa o naukę zawodu, 
                    zabezpiecz sobie tyły i najpierw poszukajcie innej praktyki, żebyś nie został „na lodzie."</strong>
                  </p>
                  <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                    Chodzi tu o to, że jeżeli rozwiążesz umowę, a nie znajdziesz praktyk w ciągu 
                    <strong> 2 tygodni albo miesiąca</strong> (okres ten zależy od Statutu szkoły do której chodzisz), 
                    może się okazać, że zostaniesz skreślony z listy uczniów Branżowej Szkoły I stopnia.
                  </p>
                </Card.Body>
              </Card>
            </motion.div>

            {/* PROCESS SECTION */}
            <motion.div
              {...fadeInUp}
              transition={{ delay: 0.2 }}
              className="mb-4"
            >
              <Card className="border-0 shadow-lg" style={{ 
                borderRadius: '20px',
                background: 'rgba(255,255,255,0.03)',
                border: '2px solid rgba(255,255,255,0.2)'
              }}>
                <Card.Body className="p-4">
                  <h5 className="fw-bold mb-4 text-white">
                    <FaExchangeAlt className="me-2" style={{ color: '#4facfe' }} />
                    Jak przeprowadzić zmianę praktyk?
                  </h5>
                  <p className="mb-4" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                    Dlatego zmiany zaczynaj od znalezienia nowego miejsca praktyk. Kiedy masz już je w 100% pewne, 
                    idziesz wraz z rodzicem do pracodawcy i składasz dokument w dwóch egzemplarzach, 
                    w którym prosisz o rozwiązanie umowy. Możesz to zrobić:
                  </p>

                  {/* OPTION A */}
                  <div className="mb-4 p-3 rounded" style={{
                    background: 'rgba(40, 167, 69, 0.1)',
                    border: '2px solid rgba(40, 167, 69, 0.3)',
                    borderRadius: '15px'
                  }}>
                    <h6 className="fw-bold mb-3" style={{ color: '#28a745' }}>
                      a. Za porozumieniem stron
                    </h6>
                    <p className="mb-2" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                      Ze wskazaniem terminu kiedy umowa ulegnie rozwiązaniu, ale tu obie strony muszą się zgodzić 
                      na wskazany termin. Ta opcja jest dla młodocianego najkorzystniejsza, ale jeśli pracodawca 
                      nie wyrazi zgody na wskazany termin musisz skorzystać z wariantu „b"
                    </p>
                    <p className="mb-0 fst-italic" style={{ fontSize: '0.9rem' }}>
                      (wzory dokumentów w zakładce SIGMY)
                    </p>
                  </div>

                  {/* OPTION B */}
                  <div className="p-3 rounded" style={{
                    background: 'rgba(102, 126, 234, 0.1)',
                    border: '2px solid rgba(102, 126, 234, 0.3)',
                    borderRadius: '15px'
                  }}>
                    <h6 className="fw-bold mb-3" style={{ color: '#667eea' }}>
                      b. Z zachowaniem terminu wypowiedzenia
                    </h6>
                    <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                      Czyli <strong>2 tygodnie lub 1 miesiąc</strong>, a zależy to od tego jak długo pracowałeś 
                      u tego konkretnego pracodawcy
                    </p>
                  </div>
                </Card.Body>
              </Card>
            </motion.div>

            {/* REMEMBER CARD */}
            <motion.div
              {...fadeInUp}
              transition={{ delay: 0.3 }}
              className="mb-4"
            >
              <Card
                className="border-0 shadow-lg"
                style={{
                  borderRadius: '20px',
                  background: 'rgba(220, 53, 69, 0.1)',
                  border: '2px solid rgba(220, 53, 69, 0.3)'
                }}
              >
                <Card.Body className="p-4">
                  <h5 className="fw-bold mb-3">
                    <FaExclamationTriangle className="me-2" style={{ color: '#dc3545' }} />
                    PAMIĘTAJ !
                  </h5>
                  <p className="mb-3" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                    Od pracodawcy od którego odchodzisz <strong>musisz otrzymać świadectwo pracy</strong>. 
                    Z tym świadectwem idziesz do „nowego" pracodawcy i na tej podstawie zostanie skonstruowana 
                    nowa umowa o pracę w celu przygotowania zawodowego.
                  </p>
                  <p className="mb-3" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                    Miesiące lub lata u poprzedniego pracodawcy <strong>sumują się z okresem pracy</strong> u nowego 
                    pracodawcy tak aby w sumie było to 36 miesięcy.
                  </p>
                  <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                    W procesie zwolnienia i nawiązania nowej współpracy uczestniczy rodzic.
                    <br />
                    <strong>Kopię nowej umowy zanosisz do szkoły.</strong>
                  </p>
                </Card.Body>
              </Card>
            </motion.div>

            {/* ADDITIONAL INFO */}
            <motion.div
              {...fadeInUp}
              transition={{ delay: 0.4 }}
              className="mb-4"
            >
              <Card className="border-0 shadow-lg" style={{ 
                borderRadius: '20px',
                background: 'rgba(67, 233, 123, 0.1)',
                border: '2px solid rgba(67, 233, 123, 0.3)'
              }}>
                <Card.Body className="p-4">
                  <h5 className="fw-bold mb-3">
                    <FaCheckCircle className="me-2" style={{ color: '#43e97b' }} />
                    Dobre wieści
                  </h5>
                  <ul className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.8' }}>
                    <li className="mb-2">
                      Praktyki możesz zmienić <strong>w każdym momencie roku szkolnego</strong>
                    </li>
                    <li className="mb-2">
                      Przepisy <strong>nie precyzują ile razy</strong> można zmieniać praktyczną naukę zawodu
                    </li>
                    <li className="mb-2">
                      W związku ze zmianą miejsca nauki zawodu <strong>nie musisz płacić pracodawcy kary 
                      ani żadnego zadośćuczynienia</strong>
                    </li>
                  </ul>
                </Card.Body>
              </Card>
            </motion.div>

            {/* WARNING */}
            <motion.div
              {...fadeInUp}
              transition={{ delay: 0.5 }}
            >
              <Alert variant="warning" className="border-0 shadow-lg" style={{ borderRadius: '15px' }}>
                <Alert.Heading>
                  <FaExclamationTriangle className="me-2" />
                  Uwaga!
                </Alert.Heading>
                <p className="mb-0">
                  Nie warto jednak przesadzać z ilością zmian, bo wpływa to na zmniejszającą się szansę ich znalezienia. 
                  Trudno też znaleźć praktyki w kl. III BS I stopnia, szczególnie w drugim półroczu.
                </p>
              </Alert>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Internships;